var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-footer',{staticClass:"d-flex justify-end d-print-none",attrs:{"app":"","color":_vm.appColor,"dark":""}},[_c('v-list-item',[_c('v-spacer'),_c('span',{},[_vm._v("พบปัญหาการใช้งาน ติดต่อ (ธวัชชัย) ฝ่ายเทคโนโลยีสารสนเทศ โทร. 1951")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }